import React from 'react'
import Helmet from 'react-helmet'

const BrowserTitle = ({ title }) => {
  const defaultTitle = 'Online Services'
  return (
    <Helmet>
      <title>{title ? title : defaultTitle} </title>
    </Helmet>
  )
}
export { BrowserTitle, withTitle }

const withTitle = ({ component: Component, title }) => {
  return class Title extends React.Component {
    render() {
      return (
        <React.Fragment>
          <BrowserTitle title={title} />
          <Component {...this.props} />
        </React.Fragment>
      )
    }
  }
}
